import React, { FC, Fragment, useState } from 'react';
import { Link as ScrollLink, Events } from 'react-scroll';
import Share from '@components/challenge/challengeDetailInfo/share';
import { MatchingChallengeTabVO } from '@domain/vo/challenge/MatchingChallengeVO';
import classNames from 'classnames/bind';
import styles from '../challengeDetailInfo.module.scss';

const cx = classNames.bind(styles);

interface ChallengeTabElProps {
  challengeTab: MatchingChallengeTabVO;
  idx: number;
  currentTabIdx: number;
  setCurrentTabIdx: (currentTabIdx: number) => void;
  scrollMode: string;
  setScrollMode: (scrollMode: string) => void;
}

const challengeTabEl: FC<ChallengeTabElProps> = ({
  challengeTab,
  idx,
  currentTabIdx,
  setCurrentTabIdx,
  scrollMode,
  setScrollMode,
}) => {
  const handleTabClick = (index: number) => {
    setScrollMode('CLICK');
    setCurrentTabIdx(index);

    Events.scrollEvent.register('end', () => {
      setScrollMode('SCROLL');
    });
  };

  const handleSetActive = (index: number) => {
    if (scrollMode !== 'SCROLL') return;
    setCurrentTabIdx(index);
  };

  if (idx === 0) {
    return (
      <Fragment key={idx}>
        <ScrollLink
          onClick={() => handleTabClick(idx)}
          to={`challengeTab_${idx}`}
          smooth={true}
          className={cx('tab', { on: currentTabIdx === 0 })}
          offset={-90}
          onSetActive={() => handleSetActive(idx)}
          spy={true}
          role={'button'}
        >
          {challengeTab.name}
        </ScrollLink>
        <ScrollLink
          onClick={() => handleTabClick(idx + 1)}
          to={`challengeTab_${idx + 1}`}
          smooth={true}
          className={cx('tab', { on: currentTabIdx === idx + 1 })}
          offset={-90}
          onSetActive={() => handleSetActive(idx + 1)}
          spy={true}
          role={'button'}
        >
          참여 포지션
        </ScrollLink>
      </Fragment>
    );
  }

  return (
    <ScrollLink
      key={idx}
      onClick={() => handleTabClick(idx + 1)}
      to={`challengeTab_${idx + 1}`}
      smooth={true}
      className={cx('tab', { on: currentTabIdx === idx + 1 })}
      offset={-90}
      onSetActive={() => handleSetActive(idx + 1)}
      spy={true}
      role={'button'}
    >
      {challengeTab.name}
    </ScrollLink>
  );
};

interface ChallengeTabsProps {
  challengeTabs: MatchingChallengeTabVO[];
  currentTabIdx: number;
  setCurrentTabIdx: (state: number) => void;
}

const ChallengeTabList: FC<ChallengeTabsProps> = ({ challengeTabs, currentTabIdx, setCurrentTabIdx }) => {
  const [scrollMode, setScrollMode] = useState<string>('SCROLL');
  const challengeTabList = challengeTabs.map((challengeTab, idx) =>
    challengeTabEl({ challengeTab, idx, currentTabIdx, setCurrentTabIdx, scrollMode, setScrollMode }),
  );

  return (
    <div className={cx('stickyArea')}>
      <div className={cx('tabArea')}>{challengeTabList}</div>
      <Share />
    </div>
  );
};

export default ChallengeTabList;
